import React from 'react';

const SearchHeader = ({ rfqId }) => (
  <div 
    className="search-header-box"
    style={rfqId ? { background: 'linear-gradient(to right, #F9FEFF, #EEC7E9)' } : {}}
  >
    <h1 className="search-header-title">
      {rfqId ? "Your AI Matches Are In" : "Looking for the right factory? Start here."}
    </h1>
    <p className="search-header-subtitle">
      Search vetted manufacturing partners nearshore and get production moving with less friction.
    </p>
  </div>
);

export default SearchHeader; 